import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { NavContext } from '../../../contexts';

import { ComuneCompetenzaContext } from '../ComuneCompetenzaContext';

import { Field, Formik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';

import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import { Autocomplete } from 'formik-material-ui';
import { DateTableRow, UtenteTableRow } from '../../../common';

const ComuneCompetenzaSchema = Yup.object().shape({
    competenzaId: Yup.number().required("La competenza è un campo obbligatorio"),
});

export function ComuneCompetenzaForm({
    disabled,
    formRef,
    onActionClick,
    ...props
}) {
    const {
        goBack,
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingUfficioComuneCompetenza,
        getUfficioComuneCompetenzaAsync,

        isUpdatingUfficioComuneCompetenza,
        updateUfficioComuneCompetenzaAsync,

        isAddingUfficioComuneCompetenza,
        addUfficioComuneCompetenzaAsync,

        isLoadingCompetenze,
        getCompetenzeAsync,

        isLoadingUffici,
        getUfficiAsync,
    } = useContext(ComuneCompetenzaContext);

    const {
        ufficioComuneCompetenza,
        competenze,
        competenzeOptions,
        uffici,
        ufficiOptions,
    } = state;

    const {
        comuneId,
        competenzaId,
    } = useParams();

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            if (onActionClick)
                onActionClick("Submit", values);
    }

    return (
        <div>
            <Formik
                innerRef={formRef}
                initialValues={
                    {
                        competenzaId: ufficioComuneCompetenza?.competenzaId ?? null,
                        ufficioId: ufficioComuneCompetenza?.ufficioId ?? null,
                        messaggio: ufficioComuneCompetenza?.messaggio ?? "",
                        inizioValidita: ufficioComuneCompetenza?.inizioValidita ?? moment.utc([1946, 5, 2]),
                        fineValidita: ufficioComuneCompetenza?.fineValidita ?? null,
                    }
                }
                enableReinitialize
                validationSchema={ComuneCompetenzaSchema}
                onSubmit={handleOnSubmit}
            >
                {({
                    values,
                    handleSubmit,
                    handleChange,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                }) => {
                    return <form onSubmit={handleSubmit}>
                        <Card>
                            <CardHeader
                                sx={{ color: "white", backgroundColor: "secondary.main", }}
                                title={
                                    <Grid container alignItems="center" justifyContent="space-between">
                                        <Grid item>
                                            <Typography variant="h6">Informazioni</Typography>
                                        </Grid>
                                        <Grid item>
                                        </Grid>
                                    </Grid>
                                }
                            />
                            <Divider />
                            <CardContent sx={{ padding: "0px !important" }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell style={{ width: "20%" }}>
                                                Ufficio
                                            </TableCell>
                                            <TableCell>
                                                <Field
                                                    name="ufficioId"
                                                    component={Autocomplete}
                                                    options={ufficiOptions}
                                                    onChange={(e, value) => {
                                                        setFieldValue('ufficioId', value?.ufficioId);
                                                    }}
                                                    value={ufficiOptions.find(option => option.ufficioId == values.ufficioId) ?? null}
                                                    renderInput={(params) => <TextField {...params} label="Scegli..." />}
                                                    fullWidth
                                                />
                                                {
                                                    errors.ufficioId &&
                                                    <Typography color="error">
                                                        {errors.ufficioId}
                                                    </Typography>
                                                }
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ width: "20%" }}>
                                                Messaggio ufficio vuoto
                                            </TableCell>
                                            <TableCell>
                                                <TextField
                                                    fullWidth
                                                    id="messaggio"
                                                    name="messaggio"
                                                    value={values.messaggio}
                                                    onChange={handleChange}
                                                    error={touched.messaggio && Boolean(errors.messaggio)} />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ width: "20%" }}>
                                                Inizio validità
                                            </TableCell>
                                            <TableCell>
                                                <Field
                                                    name="inizioValidita"
                                                    component={DatePicker}
                                                    onChange={value => {
                                                        if (value?.isValid)
                                                            setFieldValue('inizioValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                        else
                                                            setFieldValue('inizioValidita', null);

                                                    }}
                                                    inputFormat="DD/MM/YYYY"
                                                    minDate={moment.utc([1946, 5, 2])}
                                                    value={values.inizioValidita}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    fullWidth
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ width: "20%" }}>
                                                Fine validità
                                            </TableCell>
                                            <TableCell>
                                                <Field
                                                    name="fineValidita"
                                                    component={DatePicker}
                                                    onChange={value => {
                                                        if (value?.isValid)
                                                            setFieldValue('fineValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                        else
                                                            setFieldValue('fineValidita', null);
                                                    }}
                                                    inputFormat="DD/MM/YYYY"
                                                    minDate={moment.utc([1946, 5, 2])}
                                                    value={values.fineValidita}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    fullWidth
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <UtenteTableRow label={'Creato da'} utenteId={ufficioComuneCompetenza?.creatoDa} />
                                        <DateTableRow label={'Data creazione'} stringDate={ufficioComuneCompetenza?.dataCreazione} />
                                        <UtenteTableRow label={'Ultima modifica da'} utenteId={ufficioComuneCompetenza?.aggiornatoDa} />
                                        <DateTableRow label={'Data ultima modifica'} stringDate={ufficioComuneCompetenza?.dataAggiornamento} />
                                    </TableBody>
                                </Table>
                            </CardContent>
                        </Card>
                    </form>
                }}
            </Formik>
        </div>
    );
}